/**
 * Penanda offline-cache (spec CP12): service worker memberi tahu halaman bila
 * data dinamis tersaji dari cache karena jaringan terputus (bukan error
 * koneksi mentah). State tingkat halaman, satu sumber kebenaran untuk banner
 * "Jaringan terputus" di kedua mode.
 */
import { useSyncExternalStore } from 'react';

export type OfflineNotice = 'offline-cache' | null;

let state: OfflineNotice = null;
const listeners = new Set<() => void>();

export function offlineNoticeState(): OfflineNotice {
  return state;
}

export function resetOfflineNotice(): void {
  if (state === null) return;
  state = null;
  for (const listener of listeners) listener();
}

function setState(next: OfflineNotice): void {
  if (state === next) return;
  state = next;
  for (const listener of listeners) listener();
}

/** Dipanggil pendaftar message SW (main.tsx). Tanpa SW → tak pernah aktif. */
export function startOfflineNoticeListener(): () => void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return () => {};
  const onMessage = (event: MessageEvent): void => {
    if (event.data?.type === 'smh:offline-cache') setState('offline-cache');
    if (event.data?.type === 'smh:online') resetOfflineNotice();
  };
  navigator.serviceWorker.addEventListener('message', onMessage);
  const onOnline = (): void => {
    if (navigator.onLine) resetOfflineNotice();
  };
  globalThis.addEventListener('online', onOnline);
  return () => {
    navigator.serviceWorker.removeEventListener('message', onMessage);
    globalThis.removeEventListener('online', onOnline);
  };
}

export function useOfflineNotice(): OfflineNotice {
  return useSyncExternalStore(subscribe, offlineNoticeState, () => null);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
